import React from 'react';
import { Star } from 'lucide-react';
export function Proof() {
  return <section className="bg-sage/10 py-20 px-6" data-id="element-96">
      <div className="max-w-3xl mx-auto text-center" data-id="element-97">
        <div className="flex justify-center gap-1 mb-6" data-id="element-98">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-sage text-sage" data-id="element-99" />)}
        </div>
        <p className="text-xl md:text-2xl font-serif leading-relaxed italic text-charcoal mb-8" data-id="element-100">
          "Within the first 7 days, most moms report that the 'screaming fit'
          before bed disappears entirely. Instead of an hour of rocking and
          praying, you have a predictable 15-minute routine that ends with a
          calm, settled baby and a mother who actually has time to eat dinner."
        </p>
        <p className="font-sans text-charcoal/60 uppercase tracking-widest text-sm font-semibold" data-id="element-101">
          Clinical Observation
        </p>
      </div>
    </section>;
}